import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private activeTooltipIds = new Set<string>();
  private closeAllTooltips$ = new Subject<string>();
  private persistentTooltipData: { elementSelector: string; content: string; position: string } | null = null;
  
  get closeTooltip$() {
    return this.closeAllTooltips$.asObservable();
  }
  
  setActiveTooltip(id: string): void {
    // Close all other tooltips first
    if (this.activeTooltipIds.size > 0) {
      this.closeAllTooltips$.next(id); // Pass the new ID so it doesn't close itself
    }
    // Clear the set and add only this tooltip
    this.activeTooltipIds.clear();
    this.activeTooltipIds.add(id);
  }
  
  registerTooltip(id: string): void {
    this.activeTooltipIds.add(id);
  }
  
  clearActiveTooltip(id: string): void {
    this.activeTooltipIds.delete(id);
  }
  
  isActiveTooltip(id: string): boolean {
    return this.activeTooltipIds.has(id);
  }
  
  closeAll(exceptId?: string): void {
    this.closeAllTooltips$.next(exceptId || '');
  }

  // Store tooltip state for persistence across DOM changes
  setPersistentTooltip(elementSelector: string, content: string, position: string): void {
    this.persistentTooltipData = { elementSelector, content, position };
  }

  getPersistentTooltip(): { elementSelector: string; content: string; position: string } | null {
    return this.persistentTooltipData;
  }

  clearPersistentTooltip(): void {
    this.persistentTooltipData = null;
  }
}